import TMAppCaseFiling from './TMAppCaseFiling'
import TMmiddleCaseFiling from './TMmiddleCaseFiling'
import TMDocWritTrans from './TMDocWritTrans'
import TMAnsReexCaseFiling from './TMAnsReexCaseFiling'
export default[
    {
        name: 'TMAppCaseFiling',
        path: 'TMAppCaseFiling',
        redirect:{name:'TmAll'},
        component: () => import('@/pages/BigData/TrademarkModule/TMAppCaseFiling'),
        meta: { title: '商标【申请案件】申报 ' },
        props(route) {
            return {
                id: route.query.id
            }
        },
        children:[...TMAppCaseFiling]
    },
    {
        name: 'TMmiddleCaseFiling',
        path: 'TMmiddleCaseFiling',
        redirect:{name:'tmzjAll'},
        component: () => import('@/pages/BigData/TrademarkModule/TMmiddleCaseFiling'),
        meta: { title: '商标【中间案件】申报' },
        props(route) {
            return {
                id: route.query.id
            }
        },
        children:[...TMmiddleCaseFiling]
    },
    {
        name: 'TMAnsReexCaseFiling',
        path: 'TMAnsReexCaseFiling',
        redirect:{name:'TMoaAll'},
        component: () => import('@/pages/BigData/TrademarkModule/TMAnsReexCaseFiling'),
        meta: { title: '商标【答辩/复审案件】申报' },
        props(route) {
            return {
                id: route.query.id
            }
        },
        children:[...TMAnsReexCaseFiling]
    },
    {
        name: 'TMDocWritTrans',
        path: 'TMDocWritTrans',
        redirect:{name:'twaAll'},
        component: () => import('@/pages/BigData/TrademarkModule/TMDocWritTrans'),
        meta: { title: '商标【文案】撰写/翻译' },
        props(route) {
            return {
                id: route.query.id
            }
        },
        children:[...TMDocWritTrans]
    },
]